import React from "react";
import BaseDefault from "../core/BaseDefault";


export default function Charts_Page(){
    return(
        <BaseDefault
            styles="Charts"
            title="Charts"
        >
            
        </BaseDefault>
    )
}